import { Storage } from "aws-amplify";
import axios from "axios";
import pako from "pako";
import AWS from "aws-sdk";

const {
	REACT_APP_AWS_S3_URL_EXPIRATION,
	REACT_APP_AWS_USER_FILES_S3_BUCKET,
	REACT_APP_AWS_ACCESS_KEY_ID,
	REACT_APP_AWS_SECRET_ACCESS_KEY,
	REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION
} = process.env;

AWS.config.update({
	accessKeyId: REACT_APP_AWS_ACCESS_KEY_ID,
	secretAccessKey: REACT_APP_AWS_SECRET_ACCESS_KEY,
	region: REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION
});

const s3 = new AWS.S3();

Storage.configure({ level: "public" });

// Validate environment variables
if (!REACT_APP_AWS_S3_URL_EXPIRATION || !REACT_APP_AWS_USER_FILES_S3_BUCKET) {
	throw new Error("Missing required environment variables for AWS S3.");
}

/**
 * Fetch and decompress JSON data from S3.
 * @param {string} key - S3 object key.
 * @returns {Promise<Object>} - Parsed JSON object.
 */
const getDataFromS3 = async key => {
	try {
		const gzippedKey = key.replace(".json", ".json.gz");
		const fileUrl = await Storage.get(gzippedKey, {
			expires: REACT_APP_AWS_S3_URL_EXPIRATION
		});

		const response = await axios.get(fileUrl, { responseType: "arraybuffer" });
		const buffer = new Uint8Array(response.data);

		// Decompress using pako
		const gunzippedData = pako.ungzip(buffer, { to: "string" });

		// Parse JSON
		return JSON.parse(gunzippedData);
	} catch (error) {
		console.error(`Error fetching or processing data from S3 (key: ${key}):`, error);
	}
};

/**
 * List S3 object keys with a specific prefix and suffix.
 * @param {string} prefix - Prefix of the S3 objects to search.
 * @param {string} suffix - Suffix of the S3 objects to filter.
 * @returns {Promise<string[]>} - Array of object keys matching the suffix.
 */
const getObjectListBySuffix = async (prefix, suffix) => {
	const params = {
		Bucket: REACT_APP_AWS_USER_FILES_S3_BUCKET,
		Prefix: prefix
	};

	let matchingKeys = [];
	let isTruncated = true;

	try {
		while (isTruncated) {
			const response = await s3.listObjectsV2(params).promise();

			// Filter keys that match the suffix
			const keys = response.Contents.filter(item => item.Key.endsWith(suffix)).map(item => item.Key);

			// Collect matching keys
			matchingKeys.push(...keys);

			// Check if more pages are available
			isTruncated = response.IsTruncated;
			if (isTruncated) {
				params.ContinuationToken = response.NextContinuationToken;
			}
		}

		return matchingKeys;
	} catch (error) {
		console.error(
			`Error fetching objects from bucket "${REACT_APP_AWS_USER_FILES_S3_BUCKET}" (prefix: ${prefix}, suffix: ${suffix}):`,
			error
		);
	}
};

export { getDataFromS3, getObjectListBySuffix };
